import axios from 'axios';
import configService from '@/services/configService';

export function extractAuthKeyFromApiBody(body) {
  if (!body || typeof body !== 'object') {
    return '';
  }
  if (typeof body.authkey === 'string' && body.authkey.trim()) {
    return body.authkey.trim();
  }
  if (body.data && typeof body.data.authkey === 'string' && body.data.authkey.trim()) {
    return body.data.authkey.trim();
  }
  if (typeof body.token === 'string' && body.token.trim()) {
    return body.token.trim();
  }
  if (body.data && typeof body.data.token === 'string' && body.data.token.trim()) {
    return body.data.token.trim();
  }
  return '';
}

export default {
  async login(mobile, password) {
    return axios
      .post(`${configService.get('apiUrl')}/admin/login`, {
        mobile,
        password
      })
      .then(response => response.data)
      .catch(e => {
        throw e;
      });
  },

  async generateQmsOtp({ employeeMobile }) {
    return axios
      .post(`${configService.get('apiUrl')}/qms-otp`, { employeeMobile })
      .then(response => response.data)
      .catch(e => {
        throw e;
      });
  },

  async verifyQmsOtp({ employeeMobile, otp }) {
    return axios
      .post(`${configService.get('apiUrl')}/qms-otp-verify`, { employeeMobile, otp })
      .then(response => response.data)
      .catch(e => {
        throw e;
      });
  }
};
